// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/iam/v1/clients.proto" (package "c1.api.iam.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { UserRef } from "../../user/v1/user";
import { Duration } from "../../../../google/protobuf/duration";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientRef
 */
export interface PersonalClientRef {
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * The PersonalClient message contains information about a presonal client credential.
 *
 * @generated from protobuf message c1.api.iam.v1.PersonalClient
 */
export interface PersonalClient {
    /**
     * The unique ID of the personal client credential.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The ID of the user that this credential is created for.
     *
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
    /**
     * The datetime, in RFC3339 format, of when the PersonalClient was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the PersonalClient was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the PersonalClient was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the PersonalClient was last used.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 6
     */
    lastUsedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the PersonalClient will expire.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_time = 7
     */
    expiresTime?: Timestamp;
    /**
     * The display name of the personal client credential.
     *
     * @generated from protobuf field: string display_name = 8
     */
    displayName: string;
    /**
     * The clientID of the credential.
     *
     * @generated from protobuf field: string client_id = 9
     */
    clientId: string;
    /**
     * scoped_roles provides a list of IAM Roles
     * that this OAuth2 Client's API permissions
     * are reduced to. The permissions granted to OAuth2 Client
     * are AND'ed against the owning User's own permissions.
     *
     * @generated from protobuf field: repeated string scoped_roles = 10
     */
    scopedRoles: string[];
    /**
     * If set, only allows the CIDRs in the array to use the credential.
     *
     * @generated from protobuf field: repeated string allow_source_cidr = 11
     */
    allowSourceCidr: string[];
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceGetRequest
 */
export interface PersonalClientServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceGetResponse
 */
export interface PersonalClientServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.iam.v1.PersonalClient client = 1
     */
    client?: PersonalClient;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceUpdateRequest
 */
export interface PersonalClientServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.iam.v1.PersonalClient client = 1
     */
    client?: PersonalClient;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceUpdateResponse
 */
export interface PersonalClientServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.iam.v1.PersonalClient client = 1
     */
    client?: PersonalClient;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceListRequest
 */
export interface PersonalClientServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceListResponse
 */
export interface PersonalClientServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.iam.v1.PersonalClient list = 1
     */
    list: PersonalClient[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceDeleteRequest
 */
export interface PersonalClientServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceDeleteResponse
 */
export interface PersonalClientServiceDeleteResponse {
}
/**
 * The PersonalClientServiceCreateRequest message contains the fields for creating a new personal client.
 *
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceCreateRequest
 */
export interface PersonalClientServiceCreateRequest {
    /**
     * The display name for the new personal client.
     *
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * The list of roles to restrict the credential to.
     *
     * @generated from protobuf field: repeated string scoped_roles = 2
     */
    scopedRoles: string[];
    /**
     * An RFC3339 timestamp for when the credential should expire.
     *
     * @generated from protobuf field: google.protobuf.Duration expires = 3
     */
    expires?: Duration;
    /**
     * A list of CIDRs to restrict this credential to.
     *
     * @generated from protobuf field: repeated string allow_source_cidr = 4
     */
    allowSourceCidr: string[];
}
/**
 * The PersonalClientServiceCreateResponse message contains the created personal client and client secret.
 *
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceCreateResponse
 */
export interface PersonalClientServiceCreateResponse {
    /**
     * Create a personal client credential with the config.
     *
     * @generated from protobuf field: c1.api.iam.v1.PersonalClient client = 1
     */
    client?: PersonalClient;
    /**
     * The client secret that corresponds to the personal client. Make sure to save this, because it cannot be returned or queried again.
     *
     * @generated from protobuf field: string client_secret = 2
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceRotateSecretRequest
 */
export interface PersonalClientServiceRotateSecretRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceRotateSecretResponse
 */
export interface PersonalClientServiceRotateSecretResponse {
    /**
     * @generated from protobuf field: string client_secret = 1
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientSearchServiceSearchRequest
 */
export interface PersonalClientSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef users = 4
     */
    users: UserRef[];
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientSearchServiceSearchResponse
 */
export interface PersonalClientSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.iam.v1.PersonalClient list = 1
     */
    list: PersonalClient[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientRef$Type extends MessageType<PersonalClientRef> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientRef", [
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<PersonalClientRef>): PersonalClientRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PersonalClientRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientRef): PersonalClientRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientRef
 */
export const PersonalClientRef = new PersonalClientRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClient$Type extends MessageType<PersonalClient> {
    constructor() {
        super("c1.api.iam.v1.PersonalClient", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "last_used_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "expires_time", kind: "message", T: () => Timestamp },
            { no: 8, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 9, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "scoped_roles", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 11, name: "allow_source_cidr", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<PersonalClient>): PersonalClient {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.userId = "";
        message.displayName = "";
        message.clientId = "";
        message.scopedRoles = [];
        message.allowSourceCidr = [];
        if (value !== undefined)
            reflectionMergePartial<PersonalClient>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClient): PersonalClient {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp last_used_at */ 6:
                    message.lastUsedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastUsedAt);
                    break;
                case /* google.protobuf.Timestamp expires_time */ 7:
                    message.expiresTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresTime);
                    break;
                case /* string display_name */ 8:
                    message.displayName = reader.string();
                    break;
                case /* string client_id */ 9:
                    message.clientId = reader.string();
                    break;
                case /* repeated string scoped_roles */ 10:
                    message.scopedRoles.push(reader.string());
                    break;
                case /* repeated string allow_source_cidr */ 11:
                    message.allowSourceCidr.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClient, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_used_at = 6; */
        if (message.lastUsedAt)
            Timestamp.internalBinaryWrite(message.lastUsedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_time = 7; */
        if (message.expiresTime)
            Timestamp.internalBinaryWrite(message.expiresTime, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 8; */
        if (message.displayName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.displayName);
        /* string client_id = 9; */
        if (message.clientId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.clientId);
        /* repeated string scoped_roles = 10; */
        for (let i = 0; i < message.scopedRoles.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.scopedRoles[i]);
        /* repeated string allow_source_cidr = 11; */
        for (let i = 0; i < message.allowSourceCidr.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.allowSourceCidr[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClient
 */
export const PersonalClient = new PersonalClient$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceGetRequest$Type extends MessageType<PersonalClientServiceGetRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z]{3,20}-[a-z]{3,20}-[0-9]{5}$" } } } }
        ]);
    }
    create(value?: PartialMessage<PersonalClientServiceGetRequest>): PersonalClientServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceGetRequest): PersonalClientServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceGetRequest
 */
export const PersonalClientServiceGetRequest = new PersonalClientServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceGetResponse$Type extends MessageType<PersonalClientServiceGetResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceGetResponse", [
            { no: 1, name: "client", kind: "message", T: () => PersonalClient }
        ]);
    }
    create(value?: PartialMessage<PersonalClientServiceGetResponse>): PersonalClientServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceGetResponse): PersonalClientServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.iam.v1.PersonalClient client */ 1:
                    message.client = PersonalClient.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.iam.v1.PersonalClient client = 1; */
        if (message.client)
            PersonalClient.internalBinaryWrite(message.client, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceGetResponse
 */
export const PersonalClientServiceGetResponse = new PersonalClientServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceUpdateRequest$Type extends MessageType<PersonalClientServiceUpdateRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceUpdateRequest", [
            { no: 1, name: "client", kind: "message", T: () => PersonalClient, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<PersonalClientServiceUpdateRequest>): PersonalClientServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceUpdateRequest): PersonalClientServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.iam.v1.PersonalClient client */ 1:
                    message.client = PersonalClient.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.iam.v1.PersonalClient client = 1; */
        if (message.client)
            PersonalClient.internalBinaryWrite(message.client, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceUpdateRequest
 */
export const PersonalClientServiceUpdateRequest = new PersonalClientServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceUpdateResponse$Type extends MessageType<PersonalClientServiceUpdateResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceUpdateResponse", [
            { no: 1, name: "client", kind: "message", T: () => PersonalClient }
        ]);
    }
    create(value?: PartialMessage<PersonalClientServiceUpdateResponse>): PersonalClientServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceUpdateResponse): PersonalClientServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.iam.v1.PersonalClient client */ 1:
                    message.client = PersonalClient.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.iam.v1.PersonalClient client = 1; */
        if (message.client)
            PersonalClient.internalBinaryWrite(message.client, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceUpdateResponse
 */
export const PersonalClientServiceUpdateResponse = new PersonalClientServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceListRequest$Type extends MessageType<PersonalClientServiceListRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<PersonalClientServiceListRequest>): PersonalClientServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceListRequest): PersonalClientServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceListRequest
 */
export const PersonalClientServiceListRequest = new PersonalClientServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceListResponse$Type extends MessageType<PersonalClientServiceListResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PersonalClient },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PersonalClientServiceListResponse>): PersonalClientServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceListResponse): PersonalClientServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.iam.v1.PersonalClient list */ 1:
                    message.list.push(PersonalClient.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.iam.v1.PersonalClient list = 1; */
        for (let i = 0; i < message.list.length; i++)
            PersonalClient.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceListResponse
 */
export const PersonalClientServiceListResponse = new PersonalClientServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceDeleteRequest$Type extends MessageType<PersonalClientServiceDeleteRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z]{3,20}-[a-z]{3,20}-[0-9]{5}$" } } } }
        ]);
    }
    create(value?: PartialMessage<PersonalClientServiceDeleteRequest>): PersonalClientServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceDeleteRequest): PersonalClientServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceDeleteRequest
 */
export const PersonalClientServiceDeleteRequest = new PersonalClientServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceDeleteResponse$Type extends MessageType<PersonalClientServiceDeleteResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<PersonalClientServiceDeleteResponse>): PersonalClientServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceDeleteResponse): PersonalClientServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceDeleteResponse
 */
export const PersonalClientServiceDeleteResponse = new PersonalClientServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceCreateRequest$Type extends MessageType<PersonalClientServiceCreateRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 2, name: "scoped_roles", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "expires", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { required: false, lt: { seconds: "63115200" } } } } },
            { no: 4, name: "allow_source_cidr", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<PersonalClientServiceCreateRequest>): PersonalClientServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.scopedRoles = [];
        message.allowSourceCidr = [];
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceCreateRequest): PersonalClientServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* repeated string scoped_roles */ 2:
                    message.scopedRoles.push(reader.string());
                    break;
                case /* google.protobuf.Duration expires */ 3:
                    message.expires = Duration.internalBinaryRead(reader, reader.uint32(), options, message.expires);
                    break;
                case /* repeated string allow_source_cidr */ 4:
                    message.allowSourceCidr.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* repeated string scoped_roles = 2; */
        for (let i = 0; i < message.scopedRoles.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.scopedRoles[i]);
        /* google.protobuf.Duration expires = 3; */
        if (message.expires)
            Duration.internalBinaryWrite(message.expires, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated string allow_source_cidr = 4; */
        for (let i = 0; i < message.allowSourceCidr.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.allowSourceCidr[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceCreateRequest
 */
export const PersonalClientServiceCreateRequest = new PersonalClientServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceCreateResponse$Type extends MessageType<PersonalClientServiceCreateResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceCreateResponse", [
            { no: 1, name: "client", kind: "message", T: () => PersonalClient },
            { no: 2, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PersonalClientServiceCreateResponse>): PersonalClientServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientSecret = "";
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceCreateResponse): PersonalClientServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.iam.v1.PersonalClient client */ 1:
                    message.client = PersonalClient.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* string client_secret */ 2:
                    message.clientSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.iam.v1.PersonalClient client = 1; */
        if (message.client)
            PersonalClient.internalBinaryWrite(message.client, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string client_secret = 2; */
        if (message.clientSecret !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clientSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceCreateResponse
 */
export const PersonalClientServiceCreateResponse = new PersonalClientServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceRotateSecretRequest$Type extends MessageType<PersonalClientServiceRotateSecretRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceRotateSecretRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<PersonalClientServiceRotateSecretRequest>): PersonalClientServiceRotateSecretRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceRotateSecretRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceRotateSecretRequest): PersonalClientServiceRotateSecretRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceRotateSecretRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceRotateSecretRequest
 */
export const PersonalClientServiceRotateSecretRequest = new PersonalClientServiceRotateSecretRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceRotateSecretResponse$Type extends MessageType<PersonalClientServiceRotateSecretResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceRotateSecretResponse", [
            { no: 1, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PersonalClientServiceRotateSecretResponse>): PersonalClientServiceRotateSecretResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientSecret = "";
        if (value !== undefined)
            reflectionMergePartial<PersonalClientServiceRotateSecretResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientServiceRotateSecretResponse): PersonalClientServiceRotateSecretResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string client_secret */ 1:
                    message.clientSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientServiceRotateSecretResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string client_secret = 1; */
        if (message.clientSecret !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clientSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceRotateSecretResponse
 */
export const PersonalClientServiceRotateSecretResponse = new PersonalClientServiceRotateSecretResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientSearchServiceSearchRequest$Type extends MessageType<PersonalClientSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<PersonalClientSearchServiceSearchRequest>): PersonalClientSearchServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial<PersonalClientSearchServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientSearchServiceSearchRequest): PersonalClientSearchServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.user.v1.UserRef users */ 4:
                    message.users.push(UserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientSearchServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.user.v1.UserRef users = 4; */
        for (let i = 0; i < message.users.length; i++)
            UserRef.internalBinaryWrite(message.users[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientSearchServiceSearchRequest
 */
export const PersonalClientSearchServiceSearchRequest = new PersonalClientSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientSearchServiceSearchResponse$Type extends MessageType<PersonalClientSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PersonalClient },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PersonalClientSearchServiceSearchResponse>): PersonalClientSearchServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<PersonalClientSearchServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalClientSearchServiceSearchResponse): PersonalClientSearchServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.iam.v1.PersonalClient list */ 1:
                    message.list.push(PersonalClient.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalClientSearchServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.iam.v1.PersonalClient list = 1; */
        for (let i = 0; i < message.list.length; i++)
            PersonalClient.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientSearchServiceSearchResponse
 */
export const PersonalClientSearchServiceSearchResponse = new PersonalClientSearchServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.iam.v1.PersonalClientService
 */
export const PersonalClientService = new ServiceType("c1.api.iam.v1.PersonalClientService", [
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/iam/personal_clients/{id}", group: "Personal Client" }] }, "authz.method": { role: "VIEWER" } }, I: PersonalClientServiceGetRequest, O: PersonalClientServiceGetResponse },
    { name: "Update", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/iam/personal_clients/{client.id}", group: "Personal Client" }] }, "authz.method": { role: "EDITOR" } }, I: PersonalClientServiceUpdateRequest, O: PersonalClientServiceUpdateResponse },
    { name: "List", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/iam/personal_clients", summary: "NOTE: Only shows personal clients for the current user.", group: "Personal Client" }] }, "authz.method": { role: "VIEWER" } }, I: PersonalClientServiceListRequest, O: PersonalClientServiceListResponse },
    { name: "Delete", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/iam/personal_clients/{id}", group: "Personal Client" }] }, "authz.method": { role: "EDITOR" } }, I: PersonalClientServiceDeleteRequest, O: PersonalClientServiceDeleteResponse },
    { name: "Create", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/iam/personal_clients", group: "Personal Client" }] }, "authz.method": { role: "EDITOR" } }, I: PersonalClientServiceCreateRequest, O: PersonalClientServiceCreateResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.iam.v1.PersonalClientSearchService
 */
export const PersonalClientSearchService = new ServiceType("c1.api.iam.v1.PersonalClientSearchService", [
    { name: "Search", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/iam/personal_clients", summary: "NOTE: Searches personal clients for all users", group: "Personal Client" }] }, "authz.method": { role: "VIEWER" } }, I: PersonalClientSearchServiceSearchRequest, O: PersonalClientSearchServiceSearchResponse }
]);
